import { motion } from "framer-motion";

export default function OurImpact() {
  const stats = [
    { number: "10,000+", label: "Alumni Worldwide" },
    { number: "40+", label: "Countries Represented" },
    { number: "85%", label: "Alumni in Leadership Roles" },
    { number: "$1M+", label: "Scholarships & Funds Raised" },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6"
        >
          Our Impact
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-gray-600 max-w-2xl mx-auto mb-12"
        >
          Our alumni make a difference across industries, communities, and the
          world. Here are just a few numbers that showcase our collective
          impact.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-gray-50 rounded-2xl p-6 shadow-md"
            >
              <div className="text-3xl font-bold text-primary-600 mb-2">
                {stat.number}
              </div>
              <p className="text-gray-700 text-sm">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
